// Mutations
export const SET_DATA = 'SET_STORAGES_DATA';

// Actions
export const INIT_STORAGES = 'INIT_STORAGES';
